<template>
  <div class="footer">
    <span class="footer__text">© 2021</span>
    <a class="footer__text footer__link" href="http://kimiashz.com/">Kimia Shz</a>. 
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="sass" scoped>
@import "@/styles/_variables.sass"

.footer
  font-size: 0.9rem
  &__text
    display: inline-block
    line-height: 25px
    height: 25px
  &__link
    font-family: $font-secondary
    font-weight: bold
</style>
